import type { StyleProps } from '@chakra-ui/react'

// eslint-disable-next-line local/enforce-shw-link
import type { ShwLinkProps } from '@/components/ShwLink'

import AuthLink from './AuthLink'

/**
 * @deprecated Use AuthLink component with mode="signup" instead
 */
export default function SignUpLink({
  href = null,
  children,
  width,
  ...props
}: {
  href?: string | null
  children: React.ReactNode
  width?: StyleProps['width']
} & Omit<ShwLinkProps, 'href'>): JSX.Element {
  return (
    <AuthLink mode="signup" returnTo={href} width={width} {...props}>
      {children}
    </AuthLink>
  )
}
